import {Type} from 'class-transformer';
import {Manufacturer} from '../manufacturer/manufacturer';
import {Forecast} from '../forecast/forecast';
import {ContainerCustomFieldValue} from '../container-custom-field-value/container-custom-field-value';
import {PlanningParameterItem} from '../planning-parameter-item/planning-parameter-item';

export class Container {
    public readonly id!: string;
    public readonly unLoCodeLoadingPort!: string;
    public readonly unLoCodeDestinationPort!: string;
    public readonly masterBillOfLadingReference!: string;
    public readonly oceanCarrierCode!: string;
    public readonly lastPushToShippeo!: string;
    public readonly moduleWattage!: number;
    public readonly purchaseOrderId!: string;
    public readonly etdFactory!: Date;
    public readonly etdPort!: Date;
    public readonly etaDestinationPort!: Date;
    public readonly inbondDate!: Date;

    @Type(() => PlanningParameterItem)
    public readonly item?: PlanningParameterItem;

    @Type(() => Manufacturer)
    public readonly manufacturer!: Manufacturer;

    @Type(() => Forecast)
    public readonly forecast!: Forecast;

    @Type(() => ContainerCustomFieldValue)
    public readonly customValues: ContainerCustomFieldValue[] = [];
}
